import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import './index.less';
import {connect} from 'react-redux';
import ModalTopMenuList from 'components/ui/modal/modal-top-menu-list';
import ModalTopMenuListItem from 'components/ui/modal/modal-top-menu-list-item';
import BaseEditorFormComponent from 'components/modules/base/base-editor-form';
import Block from 'components/ui/form/block';
import Button from 'components/ui/button';
import FeedbackComponent from 'components/modules/feedback/feedback';
import _ from 'lodash';
import {
    checkRegisterRequestCreate, createRegisterRequest, getRegisterRequest, loginRegisterRequest,
    updateRegisterRequest
} from 'store/reducers/register';
import GlobalLoaderComponent from 'components/ui/global-loader';
import $ from 'jquery';
import * as alerts from 'helpers/alerts';
import moment from 'moment';
import formats from 'dictionaries/formats';
import systems from 'dictionaries/systems';
import {getDictionaryList} from 'store/reducers/dictionary';
import FileReaderInput from 'react-file-reader-input';
import {api} from 'helpers/api';
import * as rfc2253 from 'rfc2253';
import Script from 'react-load-script';
import {getUnit} from "store/reducers/organizational_units/carriers";

@connect((state) => ({}), {
    checkRegisterRequestCreate,
    getRegisterRequest,
    createRegisterRequest,
    updateRegisterRequest,
    getDictionaryList,
    loginRegisterRequest,
    getUnit,
})

export default class RegisterComponent extends BaseEditorFormComponent {

    state = {
        step: 1,
        loading: false,
        errors: [],
        register_request: {
            documents: [],
        },
        certificates: [],
        selected_certificate: null,
        request_documents: [],
        documentIndex: null,
        new_document: {},
    };

    cadesLoaded = false;

    componentWillMount() {
        this.loadDictionaries([
            'request_documents',
        ]);
        if (this.props.params.uuid) {
            this.loadRegisterRequest(this.props.params.uuid);
        }

        if(window.RNIS_SETTINGS.ECPOFF) {
            this.setValue('register_request.certificate.serial', '_ecpoff');
            this.setValue('register_request.certificate.valid_to', '2030-01-01T00:00:00+03:00');
            this.setValue('register_request.certificate.issuer', '_ecpoff');
        }
        if (this.props.location.query.debug) {
            this.setState({
                certificates: [
                    {
                        label: 'Test certificate',
                        value: 0,
                        certificate: {
                            thumbprint: 'test',
                            certTillDate: '2020-01-01',
                            issuerName: 'test',
                            subjectName: 'test',
                        },
                    },
                ],
            });
        }
    }

    async loadRegisterRequest(uuid) {
        this.startLoad();
        const response = await this.props.getRegisterRequest(uuid);
        this.endLoad();

        if (response.isOk) {
            this.setState({
                step: 3,
                register_request: response.payload,
            });
        } else {
            response.showErrors();
        }
    }

    startLoad() {
        this.setState({
            loading: true,
        });
    }

    endLoad() {
        this.setState({
            loading: false,
        });
    }

    get(fieldName, defaultValue = null) {
        return _.get(this.state.register_request, fieldName, defaultValue);
    }

    canGotoStep2() {
        return (
            this.get('login')
            &&
            this.get('email')
            &&
            this.get('password')
            &&
            this.get('password') === this.get('password_confirm')
        );
    }

    async gotoStep2() {
        this.setState({
            errors: [],
        });
        this.startLoad();
        const response = await this.props.checkRegisterRequestCreate(this.state.register_request);
        this.endLoad();

        if (response.isOk) {
            this.setState({
                step: 2,
            });
        } else {
            this.setState({
                errors: response.validationErrors,
            });
            response.showErrors();
        }
    }

    getStep1() {
        return (
            <div>
                <div className="page-block__top">
                    <div className="page-block__title">Шаг 1 - учетные данные мастер-аккаунта организации</div>
                    <div className="page-block__desc">После завершения процесса регистрации мастер-аккаунт позволит
                        самостоятельно в упрощенном порядке
                        создавать дополнительные учетные записи пользователей РНИС от Вашей организации.
                    </div>
                    <hr/>
                </div>
                <div>
                    <div>
                        <Block title="Наименование учетной записи">
                            {this.textInput('register_request.login')}
                        </Block>
                    </div>
                    <div>
                        <Block title="Электронная почта">
                            {this.textInput('register_request.email')}
                        </Block>
                    </div>
                    <div>
                        <Block title="Пароль">
                            {this.textInput('register_request.password', {
                                type: 'password',
                            })}
                        </Block>
                    </div>
                    <div>
                        <Block title="Подтверждение пароля">
                            {this.textInput('register_request.password_confirm', {
                                type: 'password',
                            })}
                            {(this.get('password') && this.get('password_confirm') && (this.get('password') !== this.get('password_confirm'))) ? (
                                <div className="input__style_state_wrong">
                                    <span className="input__style_state_msg_wrong">Пароли не совпадают</span>
                                </div>
                            ) : null}
                        </Block>
                    </div>
                </div>
                <div className="page-block__bottom">
                    <Button color="red" shadow="red" text="Продолжить" size="md" disabled={!this.canGotoStep2()}
                            onClick={::this.gotoStep2}/>
                </div>
            </div>
        );
    }

    cryptoproError(error) {
        alerts.error('КриптоПро: ' + error);
    }

    getEcpPart(subject, part) {
        if (this.props.location.query.debug) {
            if (part === 'SN') {
                return 'Иванов';
            }
            if (part === 'G') {
                return 'Иван Иванович';
            }
            if (part === 'ИНН') {
                return _.random(1000000000, 9999999999).toString();
            }
            return 'test';
        }
        return rfc2253.parse(subject).get(part) || '';
    }

    cadesOnLoad() {
        this.cryptopro.CheckForPlugIn((version) => {
            this.cryptopro.GetCertificates((list) => {
                if (list.length === 0) {
                    this.cryptoproError('не найден сертификат');
                    return;
                }
                if (this.cadesLoaded) {
                    return;
                }
                this.cadesLoaded = true;

                const certificates = _.map(list, (cert, index) => {
                    let cn = this.getEcpPart(cert.subjectName, 'CN');
                    while (cn.indexOf('""') !== -1) {
                        cn = cn.replace(/""/g, '"');
                    }
                    const ogrn = this.getEcpPart(cert.subjectName, 'ОГРН') || this.getEcpPart(cert.subjectName, 'OGRN');
                    let inn = this.getEcpPart(cert.subjectName, 'ИНН') || this.getEcpPart(cert.subjectName, 'INN');
                    const isPrivate = (inn && inn.substr(0, 1) !== '0') && !ogrn;
                    inn = inn.replace(/^[0]+/, '')
                    const sn = this.getEcpPart(cert.subjectName, 'SN');
                    const g = this.getEcpPart(cert.subjectName, 'G');
                    let label = cn;
                    if (inn && sn && g && !isPrivate) {
                        label = `${cn} (ИНН ${inn}, ${sn} ${g})`;
                    } else if (inn) {
                        label = `${cn} (ИНН ${inn})`;
                    }

                    return {
                        label,
                        value: index,
                        certificate: cert,
                    };
                });

                this.setState({
                    certificates,
                });
            });
        }, (error) => {
            this.cryptoproError(error);
        })
    }

    onCertificateSelect(e) {
        const value = e ? e.value : null;
        const certificate = e ? e.certificate : null;

        this.setValue('selected_certificate', value);

        this.setValue('register_request.certificate.serial', certificate ? certificate.thumbprint : null);
        this.setValue('register_request.certificate.valid_to', certificate ? moment(certificate.certTillDate).format(formats.DATE_API) : null);
        this.setValue('register_request.certificate.issuer', certificate ? this.getEcpPart(certificate.issuerName, 'CN') : null);
        this.setValue('register_request.certificate.owner', certificate ? _.filter([this.getEcpPart(certificate.subjectName, 'SN'), this.getEcpPart(certificate.subjectName, 'G')]).join(' ') : null);
        this.setValue('register_request.certificate.name', certificate ? this.getEcpPart(certificate.subjectName, 'CN') : null);
        this.setValue('register_request.certificate.inn', certificate ? this.parseINN(
            this.getEcpPart(certificate.subjectName, 'ИНН')
            ||
            this.getEcpPart(certificate.subjectName, 'INN')
        ) : null);
        this.setValue('register_request.certificate.ogrn', certificate ? (
            this.getEcpPart(certificate.subjectName, 'ОГРН')
            ||
            this.getEcpPart(certificate.subjectName, 'OGRN')
        ) : null);
        this.setValue('register_request.certificate.address', certificate ? _.filter([this.getEcpPart(certificate.subjectName, 'L'), this.getEcpPart(certificate.subjectName, 'STREET') || this.getEcpPart(certificate.subjectName, 'ST')]).join(' ') : null);
        this.setValue('register_request.certificate.position', certificate ? (this.getEcpPart(certificate.subjectName, 'TITLE') || this.getEcpPart(certificate.subjectName, 'T')) : null);
    }

    parseINN(inn) {
        return inn.replace(/^([0]+)/, '')
    }

    canGotoStep3() {
        return (
            this.get('certificate.serial')
            &&
            this.get('certificate.valid_to')
            &&
            this.get('certificate.issuer')
            &&
            this.get('certificate.owner')
            &&
            this.get('certificate.name')
            &&
            this.get('certificate.inn')
            &&
            this.get('certificate.ogrn')
            &&
            this.get('certificate.address')
            &&
            this.get('certificate.position')
        );
    }

    async gotoStep3() {
        const unit = await this.checkUnit();
        if (unit) {
            this.registerInUnit(unit);
        } else {
            this.setState({
                step: 3,
            });
        }
    }

    async registerInUnit(unit) {
        let request = _.cloneDeep(this.state.register_request);
        request.unit_uuid = unit.uuid;

        const response = await this.props.createRegisterRequest(request);

        if (response.isOk) {
            alerts.success('Учетная запись успешно создана; реквизиты для доступа к Системе высланы на указанный email', null, () => {
                this.props.router.push(`/`);
            });
        } else {
            response.showErrors();
        }
    }

    async checkUnit() {
        const response = await this.props.getUnit(this.get('certificate.inn'), this.get('certificate.ogrn'));

        if (response.isOk) {
            return response.payload;
        }

        return false;
    }

    showFeedback() {
        this.refs.page.onFeedbackClick();
    }

    getStep2() {
        if (!this.props.location.query.debug && !window.RNIS_SETTINGS.ECPOFF) {
            this.cryptopro = new cadesPluginWrapper(
                ::this.cadesOnLoad,
                (error) => {
                    this.cryptoproError(error);
                }
            );
        }

        return (
            <div>
                <div className="page-block__top">
                    <div className="page-block__title">Шаг 2 - реквизиты организации</div>
                    {!window.RNIS_SETTINGS.ECPOFF ? (
                        <div>
                            <div className="page-block__desc">Для продолжения регистрации требуется действующая электронная
                                подпись представителя юридического лица.
                            </div>
                            <p>С более детальными требованиями к электронной подписи и инструкциями по её применению в РНИС
                                можно ознакомиться <a className="link" href="/page/register" target="_blank">здесь</a>.<br/>
                                В случае возникновения вопросов по процедуре регистрации свяжитесь с оператором по форме
                                &nbsp;
                                <a className="link" href="javascript:void(0)" onClick={::this.showFeedback}>обратной связи</a>.
                            </p>
                        </div>
                    ): null}
                    <hr/>
                </div>
                <div>
                    {window.RNIS_SETTINGS.ECPOFF ? (
                        <div>
                            <div>
                                <Block title="Владелец">
                                    {this.textInput('register_request.certificate.owner')}
                                </Block>
                            </div>
                            <div>
                                <Block title="Наименование организации">
                                    {this.textInput('register_request.certificate.name')}
                                </Block>
                            </div>
                            <div>
                                <Block title="ИНН">
                                    {this.textInput('register_request.certificate.inn')}
                                </Block>
                            </div>
                            <div>
                                <Block title="ОГРН">
                                    {this.textInput('register_request.certificate.ogrn')}
                                </Block>
                            </div>
                            <div>
                                <Block title="Адрес регистрации">
                                    {this.textInput('register_request.certificate.address')}
                                </Block>
                            </div>
                            <div>
                                <Block title="Должность">
                                    {this.textInput('register_request.certificate.position')}
                                </Block>
                            </div>

                        </div>
                    ) : (
                        <div>
                            <Block size="xl" title="Сертификат">
                                {this.select('selected_certificate', this.state.certificates, {
                                    onChange: ::this.onCertificateSelect,
                                })}
                            </Block>
                            {(this.state.selected_certificate !== null) ? (
                                <div>
                                    <div className="group">
                                        <div className="group__title">Сертификат</div>
                                        <div className="group__content">
                                            <Block size="xl" className="b-block_right" title="Сертификат ЭЦП">
                                                {this.get('certificate.serial') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="Действителен до">
                                                {this.get('certificate.valid_to') ? moment(this.get('certificate.valid_to')).format(formats.DATE) : (
                                                    <span className="error">Не найдено</span>
                                                )}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="Выдан">
                                                {this.get('certificate.issuer') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="Владелец">
                                                {this.get('certificate.owner') || <span className="error">Не найдено</span>}
                                            </Block>
                                        </div>
                                    </div>
                                    <div className="group">
                                        <div className="group__title">Представитель организации</div>
                                        <div className="group__content">
                                            <Block size="xl" className="b-block_right" title="Наименование">
                                                {this.get('certificate.name') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="ИНН">
                                                {this.get('certificate.inn') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="ОГРН">
                                                {this.get('certificate.ogrn') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="Адрес регистрации">
                                                {this.get('certificate.address') || <span className="error">Не найдено</span>}
                                            </Block>
                                            <Block size="xl" className="b-block_right" title="Должность">
                                                {this.get('certificate.position') || <span className="error">Не найдено</span>}
                                            </Block>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    )}


                </div>
                <div className="page-block__bottom">
                    <hr/>
                    <Button color="red" shadow="red" text="Продолжить" size="md" disabled={!this.canGotoStep3()}
                            onClick={::this.gotoStep3}/>
                </div>
            </div>
        );
    }

    onDocumentTypeSelect(e) {
        const value = e ? e.value : null;

        if (value) {
            this.addDocumentWithType(value);
        }
    }

    deleteDocument(index) {
        let register_request = this.state.register_request;
        register_request.documents.splice(index, 1);
        this.setState({
            register_request,
        });
    }

    getStep3() {
        const fields = {
            'register_request.login': 'Логин',
            'register_request.password': 'Пароль',
            'register_request.email': 'Email',
            'register_request.certificate.name': 'ЭЦП: наименование',
            'register_request.certificate.serial': 'ЭЦП: номер',
            'register_request.certificate.valid_to': 'ЭЦП: действителен до',
            'register_request.certificate.issuer': 'ЭЦП: выдан',
            'register_request.certificate.owner': 'ЭЦП: владелец',
            'register_request.certificate.inn': 'ЭЦП: ИНН',
            'register_request.certificate.ogrn': 'ЭЦП: ОГРН',
            'register_request.certificate.address': 'ЭЦП: адрес регистрации',
            'register_request.certificate.position': 'ЭЦП: должность',
        };

        return (
            <div>
                <div className="page-block__top">
                    <div className="page-block__title">Шаг 3 - профиль деятельности организации</div>
                    <div className="page-block__desc">Очертите профиль деятельности, которую ваша организация планирует
                        вести в РНИС
                    </div>
                    <hr/>
                </div>
                {_.map(fields, (name, field) => {
                    const error = this.getError(field);
                    return error ? (
                        <div key={field} className="input__style_state_wrong">
                            <span className="input__style_state_msg_wrong">{name}: {error}</span>
                        </div>
                    ) : null;
                })}
                <div className={this.props.params.uuid ? 'half' : ''}>
                    <Block size="xl" title="Профильные области деятельности">
                        {this.canEdit() ? this.select('register_request.components', _.map(systems, (label, value) => ({
                            value,
                            label,
                        })), {
                            multi: true,
                        }) : _.map(this.get('components'), (component) => {
                            return _.get(systems, component);
                        }).join(', ')}
                    </Block>
                </div>
                <div className="set">
                    <div className="set__title">Комплект документов</div>
                    <div className="set__content clearAfter">
                        <div className="half">
                            {this.get('documents', []).map(::this.renderDocument)}
                        </div>
                        {this.canEdit() ? (
                            <div className="half">
                                {this.renderDocumentEdit()}
                            </div>
                        ) : null}
                    </div>
                </div>
                {(this.get('history', []).length > 0) ? (
                    <div className="group">
                        <div className={this.props.params.uuid ? 'half' : ''}>
                            <div className="group__title">Ход обработки</div>
                            <Block size="xl">
                                {this.get('history', []).map(::this.renderHistory)}
                            </Block>
                            {(!this.get('status') || (this.get('status') === 'returned')) ? (
                                <Block size="xl" title="Комментарий">
                                    {this.textarea('register_request.status_comment')}
                                </Block>
                            ) : null}
                        </div>
                    </div>
                ) : null}
                <div className="page-block__bottom">
                    <hr/>
                    {(!this.get('status') || (this.get('status') === 'returned')) ? (
                        <Button size="md" color="red" shadow="red" width="auto" text="Отправить комплект"
                                onClick={::this.send}/>
                    ) : null}
                </div>
            </div>
        );
    }

    renderDocument(document, index) {
        return (
            <div key={index} className="document-set">
                <div className="document-set__title">
                    {_.get(_.find(this.state.request_documents, {value: document.request_document_uuid}), 'label')}
                </div>
                <div className="files">
                    <div className="files__item">
                        <div className="files__info">
                            <div>{document.filename}</div>
                        </div>
                        {this.canEdit() ? (
                            <div className="files-menu">
                                <span
                                    className="files-menu__item edit"
                                    onClick={this.editDocument.bind(this, index)}>Редактировать</span>
                                <span
                                    className="files-menu__item remove"
                                    onClick={this.deleteDocument.bind(this, index)}>Удалить файл</span>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    }

    editDocument(index) {
        this.setState({
            documentIndex: index,
        });
    }

    renderDocumentEdit() {
        const index = this.state.documentIndex;
        const title = (index !== null) ? 'Редактирование' : 'Добавление';

        const document = _.get(_.find(this.state.request_documents, {value: (index !== null) ? _.get(this.state, `register_request.documents.${index}.request_document_uuid`) : _.get(this.state, 'new_document.request_document_uuid')}), 'document');

        const urlError = this.getError((index !== null) ? `register_request.documents.${index}.url` : 'new_document.url');
        return (
            <div className="group group-document">
                <div className="group__content">
                    <div className="document">
                        <div className="group__title">{title} документа</div>
                        <div className="b-block _xl">
                            <div className="b-block__title">Файл</div>
                            <div className="b-block__text">
                                {this.textInput((index !== null) ? `register_request.documents.${index}.filename` : 'new_document.filename')}
                                <FileReaderInput as="binary" id="my-file-input"
                                                 onChange={this.uploadFile.bind(this, index)}>
                                    <span className="add-file">Загрузить</span>
                                </FileReaderInput>
                                {urlError ? (
                                    <div className="input__style_state_wrong">
                                        <span className="input__style_state_msg_wrong">{urlError}</span>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <Block size="xl" title="Тип документа">
                            {this.select((index !== null) ? `register_request.documents.${index}.request_document_uuid` : 'new_document.request_document_uuid', _.filter(this.state.request_documents, (document) => {
                                return _.indexOf(this.get('components'), document.document.component) !== -1;
                            }))}
                        </Block>
                        <Block title="Оформлен" className="expand-top">
                            {this.datepicker((index !== null) ? `register_request.documents.${index}.issued_at` : 'new_document.issued_at')}
                        </Block>
                        {(!document || !document.is_unlimited) ? (
                            <Block title="Истекает" className="expand-top">
                                {this.datepicker((index !== null) ? `register_request.documents.${index}.valid_to` : 'new_document.valid_to')}
                            </Block>
                        ) : null}
                        <div>
                            <div className="b-block _xl">
                                <button className="b-button b-button_red b-button_shadow_red b-button_size_md"
                                        onClick={::this.saveDocument}>Сохранить
                                </button>
                                <button className="b-button b-button_white b-button_shadow_gray b-button_size_md"
                                        onClick={::this.cancelDocument}>Отменить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    validateDocument() {
        const index = this.state.documentIndex;
        const prefix = (index !== null) ? `register_request.documents.${index}.` : 'new_document.';

        let errors = {};
        _.each([
            'filename',
            'url',
            'request_document_uuid',
            'issued_at',
            'valid_to',
        ], (field) => {
            if (!this.getValue(prefix + field)) {
                errors[prefix + field] = 'Обязательно для заполнения';
            }
        });

        this.setState({
            errors,
        });

        return _.isEmpty(errors);
    }

    saveDocument() {
        /*if (!this.validateDocument()) {
            return;
        }*/
        if (this.state.documentIndex === null) {
            let register_request = this.state.register_request;
            register_request.documents.push(this.state.new_document);
            this.setState({
                register_request,
                documentIndex: null,
                new_document: {},
            });
        } else {
            this.setState({
                documentIndex: null,
                new_document: {},
            });
        }
    }

    cancelDocument() {
        this.setState({
            documentIndex: null,
            new_document: {},
        });
    }

    renderHistory(history, index) {
        return (
            <div key={index} className="LogItem">
                <div className="LogItem-table">
                    <div
                        className="LogItem-cell LogItem-time border-right">{moment(history.timestamp).format(formats.DATETIME)}</div>
                    <div className="LogItem-cell LogItem-text">{history.text}</div>
                    <div className="LogItem-cell LogItem-user border-left">{history.comment}</div>
                </div>
            </div>
        );
    }

    async uploadFile(index, e, results) {
        const tokenInfo = await this.getUploadToken();

        let formData = new FormData();

        results.forEach(result => {
            const [e, file] = result;
            //formData.append('file', e.target.result);
            formData.append('file', file);
        });

        formData.append('token', tokenInfo.token);

        const response = await api.storage.uploadFile(tokenInfo.upload_url, formData);
        const value = response.url.replace('http://', 'https://');

        this.setValue((index !== null) ? `register_request.documents.${index}.url` : 'new_document.url', value);
        this.setValue((index !== null) ? `register_request.documents.${index}.filename` : 'new_document.filename', response.original_filename);
    }

    async getUploadToken() {
        try {
            const response = await api.storage.getUploadToken();
            return response.payload;
        } catch (e) {
            console.log('Ошибка получения токена загрузки', e);
        }
    }

    async send() {
        const documentTypes = _.map(_.filter(this.state.request_documents, (document) => {
            return _.indexOf(this.get('components'), document.document.component) !== -1;
        }), 'value');

        let full = true;
        _.each(documentTypes, (uuid) => {
            if (!_.find(this.get('documents'), {
                    request_document_uuid: uuid,
                })) {
                full = false;
            }
        });

        if (full) {
            this.sendReal();
        } else {
            alerts.confirm('Неполная комплектность документов. Продолжить?', () => {
                this.sendReal()
            });
        }
    }

    async sendReal() {
        this.startLoad();
        this.setState({
            errors: [],
        });
        const response = this.state.register_request.uuid ? await this.props.updateRegisterRequest(this.state.register_request) : await this.props.createRegisterRequest(this.state.register_request);
        this.endLoad();

        if (response.isOk) {
            if (this.state.register_request.uuid) {
                alerts.success('Заявка успешно отправлена повторно', null, () => {
                    window.location.reload();
                });
            } else {
                alerts.success('Заявка успешно создана', null, () => {
                    this.props.router.push(`/`);
                });
            }
        } else {
            response.showErrors();
            this.setState({
                errors: response.validationErrors,
            });
        }
    }

    getLoginForm() {
        return (
            <div className="page-block">
                <div className="page-block__top">
                    <div className="page-block__title">Войти</div>
                    <div className="page-block__desc">Для доступа к текущей процедуре регистрации Вашей организации в
                        РНИС, введите указанные на шаге 1
                        мастера регистрации учетные данные
                    </div>
                    <hr/>
                </div>
                <div>
                    <Block title="Логин или email">
                        {this.textInput('register_request.login')}
                    </Block>
                </div>
                <div>
                    <Block title="Пароль">
                        {this.textInput('register_request.password', {
                            type: 'password',
                        })}
                    </Block>
                </div>
                <Block size="xl">
                    <Button color="red" shadow="red" text="Вход" size="md" onClick={::this.onLogin}/>
                </Block>
            </div>
        );
    }

    async onLogin() {
        this.startLoad();
        const response = await this.props.loginRegisterRequest({
            login: this.get('login'),
            password: this.get('password'),
        });
        this.endLoad();

        if (response.isOk) {
            this.setState({
                register_request: response.payload,
                step: 3,
            });
        } else {
            response.showErrors();
        }
    }

    render() {
        const loader = this.state.loading ? <GlobalLoaderComponent/> : null;
        const form = this[`getStep${this.state.step}`]();

        return (
            <Page ref="page" pageId="Register" title="Автоматическая регистрация организаций">
                <Script url="/static/js/cryptopro/cadesplugin_api.js"/>
                <Script url="/static/js/cryptopro/cadesplugin_wrapper.js"/>
                <Script url="/static/js/cryptopro/cadesplugin_wrapper_async.js"/>

                {loader}
                {((this.props.params.type === 'login') && (this.state.step === 1)) ? (
                    this.getLoginForm()
                ) : (
                    <div>
                        <div className="page-block">
                            <div className="steps">
                                {this.renderSteps()}
                            </div>
                        </div>
                        <div className="page-block">
                            {form}
                        </div>
                    </div>
                )}
            </Page>
        );
    }

    renderSteps() {
        if (this.props.params.type === 'login') {
            return;
        }

        return _.map(_.range(3), (step) => {
            const className = classNames({
                step: true,
                current: step === this.state.step - 1,
                first: step === 0,
                last: step === 2,
                done: step < this.state.step - 1,
                disabled: step > this.state.step - 1,
            });
            return (
                <div key={step} className={className}
                     onClick={(step <= this.state.step - 1) ? this.gotoStep.bind(this, step + 1) : null}>
                    Шаг {step + 1}
                </div>
            );
        });
    }

    gotoStep(step) {
        this.setState({
            step,
        });
    }

    canEdit() {
        return !this.state.register_request.status || this.state.register_request.status === 'returned';
    }

}


// WEBPACK FOOTER //
// ./src/components/modules/register/index.js